import { DirectiveOptions } from "vue";
import hoverintent, { HoverIntentListener } from "hoverintent";
import assert from "assert";

export interface VHoverIntentOptions {
  handler(inside: boolean): void;
  timeout?: number;
}
const key = "__hoverintent__";

const vHoverIntent: DirectiveOptions = {
  bind(el, binding, vnode) {
    assert(el, "el is falsy?");
    const value = binding.value as VHoverIntentOptions;
    assert(value, "v-hover-intent has no value");
    assert(typeof value.handler === "function", "v-hover-intent 's handler in a function");
    const listener = hoverintent(
      el,
      () => {
        value.handler(true);
      },
      () => {
        value.handler(false);
      },
    ).options({
      timeout: value.timeout,
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    el[key] = listener;
  },
  unbind(el) {
    // eslint-disable-next-line
    //@ts-ignore
    const listener = el[key] as HoverIntentListener;
    assert(listener, "i planted it there");
    listener.remove();
  },
};

export default vHoverIntent;
